import { TranslateDefaultParser, TranslateParser } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomParser extends TranslateDefaultParser implements TranslateParser {
  entranslations: any;
  constructor() {
    super();
    this.getEntranslations();
  }

  interpolate(expr: string | Function, params?: any): string {
    return super.interpolate(expr, params);
  }

  getValue(target: any, key: string): any {
    const value = super.getValue(target, key);
    
    // Check if value is meaningful (including whitespace check but preserving interpolation markers)
    const isMeaningfulValue = (
      value !== key && 
      typeof value !== 'object' && 
      value != null &&
      (typeof value !== 'string' || 
       value.includes('{{') ||  // Always allow strings with interpolation markers
       value.replace(/\s|\u200B/g, '') !== '')
    );
    
    if (isMeaningfulValue) {
      return value;
    }
    
    // Fallback to entranslations if available
    if (this.entranslations) {
      const fallbackValue = super.getValue(this.entranslations, key);
      const isFallbackMeaningful = (
        fallbackValue !== key &&
        typeof fallbackValue !== 'object' &&
        fallbackValue != null &&
        (typeof fallbackValue !== 'string' || 
         fallbackValue.includes('{{') || 
         fallbackValue.replace(/\s|\u200B/g, '') !== '')
      );
      
      if (isFallbackMeaningful) {
        return fallbackValue;
      }
    }

    return key;
  }

  getEntranslations() {
    import(`../assets/translations/i18n/admin-translation.en.json`).then(
      entranslationObj => { this.entranslations = { ...this.entranslations, ...entranslationObj }; }
    );

    import(`../app/public/translations/i18n/translation.en.json`).then(
      entranslationObj => { this.entranslations = { ...this.entranslations, ...entranslationObj }; }
    );
  }
}
